module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-chalk-1-391ca2bd6a0ec2da3ffb297e5ed1cf3c.png";